var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "whatsapp_1_",
    "data-name": "whatsapp (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.333,
    height: 40.333,
    viewBox: "0 0 40.333 40.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_241641",
    "data-name": "Path 241641",
    d: "M0,40.333,2.782,30.25A20.059,20.059,0,0,1,20.1,0,20.257,20.257,0,0,1,40.333,20.028,20.5,20.5,0,0,1,20.1,40.333a20.244,20.244,0,0,1-9.805-2.782Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_241642",
    "data-name": "Path 241642",
    d: "M51.509,74.6l.626.348a16.511,16.511,0,0,0,8.693,2.573,16.859,16.859,0,0,0,16.69-16.829,16.69,16.69,0,0,0-33.379,0,16.846,16.846,0,0,0,2.573,8.971l.417.626-1.6,5.841Z",
    transform: "translate(-40.661 -40.661)",
    fill: "#55cd6c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_241643",
    "data-name": "Path 241643",
    d: "M134.234,135.132l-1.321-.07a1.579,1.579,0,0,0-1.113.417,5.761,5.761,0,0,0-1.947,2.99c-.487,2.086.278,4.59,2.086,7.093a21.074,21.074,0,0,0,11.4,8.275,5.649,5.649,0,0,0,4.729-.556,4.1,4.1,0,0,0,1.808-2.643l.209-.974a.7.7,0,0,0-.348-.765l-4.381-2.017a.664.664,0,0,0-.834.209l-1.738,2.225a.541.541,0,0,1-.556.139,13.514,13.514,0,0,1-7.3-6.259.525.525,0,0,1,.07-.556l1.669-1.878a.857.857,0,0,0,.139-.7l-2.017-4.52a.606.606,0,0,0-.556-.417",
    transform: "translate(-119.492 -124.422)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.8d59266eb48e0927566026a23f253adf.svg";
export { ForwardRef as ReactComponent };